import React from "react";
import Input from "./Input";
import validation from "./Validation";

class InputOut extends Input {
  render(){
    return(
      <Input
        {...this.props}
        type="number"
      />
    );
  }

}

const InputNumero = validation(InputOut);

export default InputNumero;